import React from 'react';
import {
    GuestGuard,
    PartnerAgentGuard,
    PartnerGuard,
} from '../guards/RolesGuard';
// import Login from '../features/auth/login';
import Register from '../features/auth/register';
// import ResetPassword from '../features/auth/reset-password';
import Layout from '../container/Layout';
import Homepage from '../features/dashboard/homepage';
import Settings from '../features/dashboard/settings';
import MembersHomepage from '../features/dashboard/member-homepage';
import MembersLogin from '../features/auth/login/members-login';
// import AdminLogin from '../features/auth/login/admin-login';
// import WelcomePage from '../features/auth/welcome';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    // {
    //     path: '/',
    //     element: <WelcomePage />,
    //     key: 'guest',
    //     guard: GuestGuard,
    // },
    {
        path: '/login',
        element: <MembersLogin />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/apply',
        element: <Register />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/insights',
        element: <Layout />,
        index: '/insights',
        key: 'broker',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Homepage />
            }
        ]
    },

    {
        path: '/member-insights',
        element: <Layout />,
        index: '/member-insights',
        key: 'broker',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <MembersHomepage />
            }
        ]
    },
    {
        path: '/settings',
        element: <Layout />,
        index: '/settings',
        key: 'broker',
        guard: PartnerGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            }
        ]
    },
];
